import { render, staticRenderFns } from "./admin_workers.vue?vue&type=template&id=8cb39c70&scoped=true"
import script from "./admin_workers.vue?vue&type=script&lang=js"
export * from "./admin_workers.vue?vue&type=script&lang=js"
import style0 from "./admin_workers.vue?vue&type=style&index=0&id=8cb39c70&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8cb39c70",
  null
  
)

export default component.exports